import { NgTemplateOutlet } from "@angular/common";
import { ChangeDetectionStrategy, Component, OnInit, ViewEncapsulation } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatDialog } from "@angular/material/dialog";
import { MatIconModule } from "@angular/material/icon";
import { MatTooltipModule } from "@angular/material/tooltip";
import { TranslocoPipe } from "@ngneat/transloco";
import { AsSoonAsPossibleComponent } from "app/modules/admin/campaign/as-soon-as/as-soon-as.component";
import { ContactUsComponent } from "app/modules/admin/campaign/contact-us/contact-us.component";
import { AcButtonComponent } from "../../../app/shared/components/ac-button/ac-button.component";

@Component({
    selector: "custom-contact-us-button",
    templateUrl: "./contact-us-button.component.html",
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [MatButtonModule, MatTooltipModule, NgTemplateOutlet, MatIconModule, AcButtonComponent, TranslocoPipe],
})
export class ContactUsButtonComponent implements OnInit {
    constructor(private _matDialog: MatDialog) {}
    ngOnInit(): void {}

    openContactUs(): void {
        this._matDialog
            .open(ContactUsComponent, {
                /* width: "400px",
                minWidth: "400px",
                maxWidth: "80vw", */
            })
            .afterClosed()
            .subscribe((data) => {
                if (data === "save") {
                    this._matDialog.open(AsSoonAsPossibleComponent);
                }
            });
    }
}
